import Vue from "vue";
import VueRouter from "vue-router";
import BaseFrontend from "../views/frontend/Base.vue";
import Auth from "../providers/AuthProviders";
import Login from "../views/frontend/product-catalogs/pages/Login.vue";
import LoginCallback from "../views/frontend/product-catalogs/pages/LoginByGoogle.vue";
import RegisterUser from "../views/frontend/product-catalogs/pages/RegisterUser.vue";
import RegisterUserCallback from "../views/frontend/product-catalogs/pages/RegisterUserCallback.vue";
import RegisterUmkm from "../views/frontend/product-catalogs/pages/RegisterUmkm.vue";
import registerUmkmCallback from "../views/frontend/product-catalogs/components/register-umkm-callback/Index.vue";

//import Register from "../views/auth/Register.vue";
import Home from "../views/frontend/product-catalogs/pages/Home.vue";
import Product from "../views/frontend/product-catalogs/pages/Product.vue";
import ProductDetail from "../views/frontend/product-catalogs/pages/ProdukDetail.vue";
import Umkm from "../views/frontend/product-catalogs/pages/Umkm.vue";

//BASE APLIKASI
import Base from "../views/backend/Base.vue";

//Exception
import PageUnderConstructions from "../views/backend/pages/exception/under-construction/Index.vue";

//Dashboard Page
import Dashboard from "../views/backend/pages/Dashboard.vue";

//Master Data App
import MasterAppInfo from "../views/backend/pages/masterdata/appinfo/Index.vue";
import MasterDataProvinsi from "../views/backend/pages/masterdata/province/Index.vue";
import MasterDataRegency from "../views/backend/pages/masterdata/regency/Index.vue";
import MasterDataDistrict from "../views/backend/pages/masterdata/district/Index.vue";
import MasterDataVillage from "../views/backend/pages/masterdata/village/Index.vue";
import MasterDataUnit from "../views/backend/pages/masterdata/unit/Index.vue";
import MasterDataCategory from "../views/backend/pages/masterdata/category/Index.vue";
import MasterDataSubCategory from "../views/backend/pages/masterdata/sub-category/Index.vue";
import MasterDataKind from "../views/backend/pages/masterdata/kind/Index.vue";
import MasterDataCriteria from "../views/backend/pages/masterdata/criteria/Index.vue";

//Utiity Group Page
import User from "../views/backend/pages/utility/user/Index.vue";
import Changepwd from "../views/backend/pages/utility/user/Changepwd.vue";
import ProfilAkun from "../views/backend/pages/utility/user/Profil.vue";
import UtilityManajemenFitur from "../views/backend/pages/utility/manajemenfitur/Index.vue";
import UtilitymanajemenFiturAdministrator from "../views/backend/pages/utility/manajemenfitur/administrator/Index.vue";
import UtilityUpdateHistory from "../views/backend/pages/utility/updatehistory/Index.vue";
import UtilityUpdateHistoryItem from "../views/backend/pages/utility/updatehistory/items/Index.vue";
import UtilityManajemenUserProvinsi from "../views/backend/pages/utility/user-provinsi/Index.vue";
import UtilityManajemenUSerKabkota from "../views/backend/pages/utility/user-kabkota/Index.vue";
import UtilityFileManagement from "../views/backend/pages/utility/filemanagement/Index.vue";

//Backend Halaman Depan
import HalamanDepanSlider from "../views/backend/pages/halamandepan/sliders/Index.vue";
import HalamanDepanSponsor from "../views/backend/pages/halamandepan/sponsors/Index.vue";
import HalamanDepanVideo from "../views/backend/pages/halamandepan/videos/Index.vue";

//page exception
import Page404 from "../views/frontend/404.vue";

/**
 * Manajemen Admin
 */
import ManajemenAdminUp2k from "../views/backend/pages/manajemen/admin/company/Index.vue";
import ManajemenAdminUp2kProfile from "../views/backend/pages/manajemen/admin/company/profile/Index.vue";
import ManajemenAdminUp2kProduct from "../views/backend/pages/manajemen/admin/products/Index.vue";

/**
 * Page UMKM
 */
import UmkmDashboard from "../views/backend/pages/umkm/dashboard/Index.vue";
import UmkmCompany from "../views/backend/pages/umkm/company/Index.vue";
import UmkmProduct from "../views/backend/pages/umkm/product/Index.vue";
import UmkmProductCreate from "../views/backend/pages/umkm/product/create/Index.vue";
import UmkmProductEdit from "../views/backend/pages/umkm/product/edit/Index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "page-not-found",
    component: Page404,
  },

  /**
   * Frontend
   */
  {
    path: "",
    name: "",
    component: BaseFrontend,
    children: [
      { path: "", redirect: { name: "product" } },
      { path: "login", name: "login", component: Login },
      {
        path: "login-callback",
        name: "login-callback",
        component: LoginCallback,
      },
      { path: "register-user", name: "register-user", component: RegisterUser },
      {
        path: "register-user-callback",
        name: "register-user-callback",
        component: RegisterUserCallback,
      },
      { path: "register-umkm", name: "register-umkm", component: RegisterUmkm },
      {
        path: "register-umkm-callback",
        name: "register-umkm-callback",
        component: registerUmkmCallback,
      },
      { path: "home", name: "home", component: Product },
      { path: "product", name: "product", component: Product },
      {
        path: "product-detail/:id",
        name: "product-detail",
        component: ProductDetail,
      },
      {
        path: "up2k/:id",
        name: "umkm",
        component: Umkm,
      },
    ],
  },

  /**
   * Route Backend
   */

  {
    path: "/auth",
    name: "",
    meta: {
      auth: true,
    },
    component: Base,
    children: [
      { path: "", redirect: { name: "dashboard" } },
      { path: "dashboard", name: "dashboard", component: Dashboard },
      { path: "user", name: "user", component: User },
      {
        path: "page-under-construction",
        name: "page-under-construction",
        component: PageUnderConstructions,
      },
      {
        path: "chngpwd",
        name: "chngpwd",
        component: Changepwd,
      },
      {
        path: "profil-akun",
        name: "profil-akun",
        component: ProfilAkun,
      },

      //route master data
      {
        path: "master-app-info",
        name: "master-app-info",
        component: MasterAppInfo,
      },
      {
        path: "master-data-province",
        name: "master-data-province",
        component: MasterDataProvinsi,
      },
      {
        path: "master-data-regency/:province_code/:province_name",
        name: "master-data-regency",
        component: MasterDataRegency,
      },
      {
        path:
          "master-data-district/:province_code/:province_name/:regency_code/:regency_name",
        name: "master-data-district",
        component: MasterDataDistrict,
      },
      {
        path:
          "master-data-village/:province_code/:province_name/:regency_code/:regency_name/:district_code/:district_name",
        name: "master-data-village",
        component: MasterDataVillage,
      },
      {
        path: "master-data-satuan",
        name: "master-data-satuan",
        component: MasterDataUnit,
      },
      {
        path: "master-data-category",
        name: "master-data-category",
        component: MasterDataCategory,
      },
      {
        path: "master-data-sub-category/:category_uuid/:category_name",
        name: "master-data-sub-category",
        component: MasterDataSubCategory,
      },
      {
        path: "master-data-jenis-usaha",
        name: "master-data-jenis-usaha",
        component: MasterDataKind,
      },
      {
        path: "master-data-kriteria",
        name: "master-data-kriteria",
        component: MasterDataCriteria,
      },

      //Route slider
      {
        path: "halaman-depan-slider",
        name: "halaman_depan_slider",
        component: HalamanDepanSlider,
      },
      //Route Sponsor
      {
        path: "halaman-depan-sponsor",
        name: "halaman-depan-sponsor",
        component: HalamanDepanSponsor,
      },
      {
        path: "halaman-depan-video",
        name: "halaman-depan-video",
        component: HalamanDepanVideo,
      },

      /**
       * Route Utility
       */
      {
        path: "utility-manajemen-fitur-administrator",
        name: "utility-manajemen-fitur-administrator",
        component: UtilitymanajemenFiturAdministrator,
      },
      {
        path: "utility-manajemen-fitur",
        name: "utility-manajemen-fitur",
        component: UtilityManajemenFitur,
      },
      {
        path: "utility-update-history",
        name: "utility-update-history",
        component: UtilityUpdateHistory,
      },
      {
        path: "utility-update-history-items/:update_history_id",
        name: "utility-update-history-items",
        component: UtilityUpdateHistoryItem,
      },
      {
        path: "utility-manajemen-user-provinsi",
        name: "utility-manajemen-user-provinsi",
        component: UtilityManajemenUserProvinsi,
      },
      {
        path: "utility-manajemen-user-kabkota",
        name: "utility-manajemen-user-kabkota",
        component: UtilityManajemenUSerKabkota,
      },
      {
        path: "utility-file-management",
        name: "utility-file-management",
        component: UtilityFileManagement,
      },

      /**
       * Route Manajemen Admin
       */
      {
        path: "manajemen-admin-up2k",
        name: "manajemen-admin-up2k",
        component: ManajemenAdminUp2k,
      },
      {
        path: "manajemen-admin-up2k-profile/:id",
        name: "manajemen-admin-up2k-profile",
        component: ManajemenAdminUp2kProfile,
      },
      {
        path: "manajemen-admin-up2k-product",
        name: "manajemen-admin-up2k-product",
        component: ManajemenAdminUp2kProduct,
      },

      /**
       * Route UMKM
       */
      {
        path: "umkm-dashboard",
        name: "umkm-dashboard",
        component: UmkmDashboard,
      },
      {
        path: "umkm-company",
        name: "umkm-company",
        component: UmkmCompany,
      },
      {
        path: "umkm-product",
        name: "umkm-product",
        component: UmkmProduct,
      },
      {
        path: "umkm-product-create",
        name: "umkm-product-create",
        component: UmkmProductCreate,
      },
      {
        path: "umkm-product-edit/:id",
        name: "umkm-product-edit",
        component: UmkmProductEdit,
      },
    ],
  },

  /**
   * Route signin
   */
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  mode: "history",
});

/**
 * router match
 */

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.auth);

  if (requiresAuth) {
    if (!Auth.check) {
      next({ name: "login" });
    } else {
      next();
    }
  } else {
    if (to.name === "login" && Auth.check) {
      if (Auth.user.authent == "superadmin") {
        next({ name: "dashboard" });
      } else if (Auth.user.authent === "administator") {
        next({ name: "dashboard" });
      } else if (Auth.user.authent == "umkm") {
        next({ name: "umkm-dashboard" });
      } else {
        next({ name: "dashboard" });
      }
    } else {
      next();
    }
  }
});

export default router;
